import PendoMultiselect from '../multiselect/pendo-multiselect.vue.js';
import PendoIconButton from '../icon-button/pendo-icon-button.vue.js';
import { pageSizeOptions } from './utils/constants.js';

var script = {
  name: 'TablePaginationControls',
  components: {
    PendoMultiselect,
    PendoIconButton
  },
  inject: ['$table'],
  data() {
    return {
      pageSizeOptions
    };
  },
  computed: {
    currentRange() {
      return {
        start: (this.$table.pageNumber - 1) * this.$table.pageSize + 1,
        end: Math.min(this.$table.pageNumber * this.$table.pageSize, this.$table.allRowsCount)
      };
    },
    lastPage() {
      return Math.ceil(this.$table.allRowsCount / this.$table.pageSize);
    }
  },
  methods: {
    onPageSizeChange(value) {
      this.$emit('update-page-size', value);
      this.goToFirstPage();
    },
    goToFirstPage() {
      this.$emit('update-page-number', 1);
    },
    goToPreviousPage() {
      if (this.$table.pageNumber > 1) {
        this.$emit('update-page-number', this.$table.pageNumber - 1);
      }
    },
    goToNextPage() {
      if (this.$table.pageNumber < this.lastPage) {
        this.$emit('update-page-number', this.$table.pageNumber + 1);
      }
    },
    goToLastPage() {
      this.$emit('update-page-number', this.lastPage);
    }
  }
};

export { script as default };
//# sourceMappingURL=table-pagination-controls.vue2.js.map
